import { MiButton } from "@miplatform/components";
import { mdiPlus } from "@mdi/js";
import { useTheme } from "@mui/material";

export const AddButton: React.FC<AddButtonProps> = ({
  label,
  onClick,
  disabled,
  className,
}) => {
  const theme = useTheme();

  return (
    <MiButton
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      className={className}
      startIcon={{
        path: mdiPlus,
        iconColor: theme.palette.common.white,
      }}
    >
      {label}
    </MiButton>
  );
};

interface AddButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}
